import { regType } from '@utils/regExp'



export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.onLoad()
      vm.setPreviousTable(from)
    })
  },
  data () {
    return {
      inputWith: 12,
      parentPage: { /** 新建客户有两个入口，指定用哪个 **/
        name: '客户列表',
        path: '/customer/table'
      },
      formRules: {
        name: [
          {required: true, message: '客户名称不能为空', trigger: 'blur'},
        ],
        number: [
          {required: true, message: '客户编号不能为空', trigger: 'blur'},
        ],
        company: [
          {required: true, message: '所属公司不能为空', trigger: 'blur'},
        ],
        'contact_persons.0.name': [
          {required: true, message: '客户联系人不能为空', trigger: 'blur'},
        ],
        'contact_persons.0.job_title': [
          {required: true, message: '职位不能为空', trigger: 'blur'},
        ],
        'contact_persons.0.phone': [
          {required: true, message: '联系方式不能为空', trigger: 'blur'},
        ],
        'contact_persons.0.email': [
          {required: true, message: '邮箱不能为空', trigger: 'blur'},
          {validator: this.emailValidator, trigger: 'blur'},
        ],
        abbr: [
          {required: true, message: '客户代码不能为空', trigger: 'blur'},
        ],
      },
      dataModel: {
        name: '',
        number: '',
        abbr: '',
        detail: '',
        type: 10,
        company: '',
        show_in_statistics: 1,
        managementfees: 0,
        supplier_code: '',
        contact_persons: [
          {
            name: '',
            job_title: '',
            phone: '',
            email: ''
          },
          {
            name: '',
            job_title: '',
            phone: '',
            email: ''
          }
        ],
      },
      optionModel: {
        customerType: [
          {label: '主平台', value: 10},
          {label: '查理宝客户', value: 20},
          {label: '星火客户', value: 30},
          {label: '标注客户', value: 40},
        ],
        display: [
          {label: '不显示', value: 0},
          {label: '显示', value: 1},
        ],
      },
      inLoading: {
        submit: false,
      },
      tip: ''
    }
  },
  computed: {},
  created () {
  },
  methods: {
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm (id) {
      request.common('getCustomerDetail', {id}).then(({data}) => {
        Object.keys(data).map(function (key) {
          let intItems = ['id', 'type', 'show_in_statistics']
          if (intItems.includes(key)) {
            data[key] = parseInt(data[key])
          }
          let floatItems = ['managementfees']
          if (floatItems.includes(key)) {
            data[key] = parseFloat(data[key]) * 100
          }
          if (data.contact_persons.length <= 1) {
            data.contact_persons.push({
              name: '',
              job_title: '',
              phone: '',
              email: '',
            })
          }
        })

        this.dataModel = data
      })
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let form = filter.copyJson(this.dataModel)
          let secondPerson = form.contact_persons[1]
          if (!secondPerson.name && !secondPerson.job_title && !secondPerson.phone && !secondPerson.email) {
            form.contact_persons.splice(1, 1)
          }
          this.id ? this.update(this.id, form) : this.create(form)
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    phoneValidator (rule, value, callback) {
      if (!regType('telephone').test(String(value))) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    },


    emailValidator (rule, value, callback) {
      if (!regType('email').test(String(value))) {
        callback(new Error('请输入正确的邮箱地址'))
      } else {
        callback()
      }
    },
    create (form) {
      request.common('createCustomerTask', form).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.$refs.form.resetFields()
        }, this.backToList)
      })
    },
    update (id, form) {
      request.common('updateCustomerData', {id, ...form}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(this.backToList)
      })
    },
    backToList () {
      this.$router.push(this.parentPage)
    },
    setPreviousTable (from) {
      if (from.meta.title || from.name) {
        this.parentPage = Object.assign({}, from)
      }
    },
    validateAbbr (value) {
      request.common('validateUniqueAbbr', {abbr: value}).then((res) => {
        if (res.data.count > 0) {
          let name = ''
          for (let i in res.data.data) {
            name += res.data.data[i].name + ','
          }
          name = name.substring(0, name.length - 1)
          if (res.data.count > 5) {
            name += '...'
          }
          this.tip = '客户代码已存在，' + name
        }
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/customer-task/pages/CustomerTaskForm.js